<div *ngIf="!mobile" class="hidden md:flex md:grid grid-nogutter">
  <ng-container *ngFor="let template of splitColumnTemplates">
    <div class="col-{{ template.colSize ?? 'fixed' }}">
      <p-scrollPanel [style]="{height: template.scrollHeight ?? '200px'}">
        <div class="flex flex-column gap-3 p-0">
          <ng-container
            *ngTemplateOutlet="
              template.template;
              context: { isCollapsed: false }
            "
          />
        </div>
      </p-scrollPanel>
    </div>
  </ng-container>
</div>

<div *ngIf="mobile" class="flex flex-column gap-3 md:hidden">
  <ng-container *ngFor="let template of splitColumnTemplates">
    <ng-container
      *ngTemplateOutlet="template.template; context: { isCollapsed: true }"
    />
  </ng-container>
</div>
